module.exports = __webpack_public_path__ + "media/react-crud.6789eaec.mp4";